import React from 'react';
import ReactDOM from 'react-dom';

import classNames from 'classnames';

import Button, { Props as ButtonProps } from '@/components/common/Button';

import Modal from './index';

import styles from './confirm.module.scss';
import { twMerge } from 'tailwind-merge';

export interface Action {
  text: string;
  props?: ButtonProps;
  onPress?: (next?) => void;
}

type ConfirmProps = {
  title?: React.ReactNode;
  message: React.ReactNode;
  okText?: string;
  cancelText?: string | React.ReactNode;
  onOk?: (close?) => void;
  onClose?: (close?) => void;
  className?: string;
  dialogClassName?: string;
  options?: {
    [key: string]: any;
  };
  isIosType?: boolean;
  okStyles?: any;
  cancelStyles?: any;
  maskStyle?: React.CSSProperties;
  maskProps?: ObjectType;
  closable?: boolean;
  closableName?: string;
  closableIconName?: string;
  maskClosable?: boolean;
  confirmClose?: (close?) => void;
  dialogContentStyle?: React.CSSProperties;
};

export default function confirm(props: ConfirmProps) {
  let {
    title,
    message,
    className,
    okText,
    onOk,
    cancelText,
    onClose,
    isIosType = false,
    okStyles,
    cancelStyles,
    dialogClassName,
    ...rest
  } = props;

  if (!title && !message) {
    return {
      close: () => {
        //
      }
    };
  }

  const div: any = document.createElement('div');
  div.className = dialogClassName;
  document.body.appendChild(div);

  function close() {
    ReactDOM.unmountComponentAtNode(div);
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  const prefixCls = 'kunlun';

  ReactDOM.render(
    <Modal
      {...rest}
      onClose={() => {
        rest?.confirmClose && rest?.confirmClose(close);
      }}
      data-testid="wid-modal-confirm"
      className={twMerge(classNames({ [styles.iosConfirm]: isIosType }, className))}
      visible
      transparent
      title={title}
      closable={rest.closable || false}
      maskClosable={rest.maskClosable || false}>
      <div data-testid="wid-modal-confirm-message" className={`${prefixCls}-alert-content mb-400`}>
        {message}
      </div>
      <div>
        {isIosType ? (
          <div className={styles.iosBtns}>
            {!!cancelText && (
              <div
                data-testid="btn-confirm-close"
                style={cancelStyles}
                className={classNames(styles.btn)}
                onClick={() => {
                  if (onClose) {
                    return onClose(close);
                  }
                  close();
                }}>
                {cancelText}
              </div>
            )}
            {!!okText && (
              <div
                data-testid="btn-confirm-ok"
                style={okStyles}
                className={styles.btn}
                onClick={() => {
                  if (onOk) {
                    return onOk(close);
                  }
                  close();
                }}>
                {okText}
              </div>
            )}
          </div>
        ) : (
          <>
            {!!okText && (
              <Button
                data-testid="btn-confirm-ok"
                bordered={false}
                style={okStyles}
                type="secondary"
                onClick={() => {
                  if (onOk) {
                    return onOk(close);
                  }
                  close();
                }}>
                {okText}
              </Button>
            )}
            {!!cancelText &&
              (typeof cancelText === 'string' ? (
                <Button
                  data-testid="btn-confirm-close"
                  bordered={false}
                  className="mt-2"
                  style={cancelStyles}
                  type="tertiary"
                  onClick={() => {
                    if (onClose) {
                      return onClose(close);
                    }
                    close();
                  }}>
                  {cancelText}
                </Button>
              ) : (
                <div
                  data-testid="btn-confirm-close"
                  onClick={() => {
                    if (onClose) {
                      return onClose(close);
                    }
                    close();
                  }}>
                  {cancelText}
                </div>
              ))}
          </>
        )}
      </div>
    </Modal>,
    div
  );

  return {
    close
  };
}
